import { useCallback, useMemo } from "react";
import type { ProductVariantAvailabilityWithChannel } from "@graphql/generated/types";
import type { StoreData } from "../types";

export const useStoreAvailability = (
    storesWithStock?: StoreData[] | ProductVariantAvailabilityWithChannel[],
    enabled = true
): ((stores: StoreData[]) => StoreData[] | undefined) => {
    const stockByChannel = useMemo(() => {
        if (!enabled || !storesWithStock) return undefined;

        return new Map(
            storesWithStock.map((stock) => {
                const supplyChannelId: string | undefined =
                    "supplyChannel" in stock ? stock.supplyChannel?.[0]?.id : undefined;
                const channelId = "channel" in stock ? stock.channel?.id : undefined;
                return [supplyChannelId ?? channelId, stock] as const;
            })
        );
    }, [storesWithStock, enabled]);

    return useCallback(
        (stores: StoreData[]): StoreData[] | undefined => {
            if (!stockByChannel) return undefined;

            return stores.flatMap((store) => {
                const stock = stockByChannel.get(store.supplyChannel?.[0]?.id);
                return stock ? [{ ...store, availability: stock.availability }] : [];
            });
        },
        [stockByChannel]
    );
};
